import React from "react";

export interface LoadingIndicatorProps {
    className?: string;
    style?: React.CSSProperties;
}
export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ className = "", style }) => {
    return <div className={`lds-dual-ring loading-indicator ${className}`} {...(style ? { style } : {})}></div>;
};
